/**
 * Später ins Netz (S62, Stufe 1; 25-zeitsteuerung.md § 7.2, § 10.4): a change that happens by itself
 * at a moment – a menu as the QR-Code-Speisekarte, the Empfehlungskarte, a PDF into a PDF link. Kept
 * in the business's settings (no table); the server's minute applies what is due, the oldest first,
 * so the newest wins. A menu and a recommendation are frozen when the moment comes (changes until
 * then come along); a PDF is made when planned (the app makes PDFs), hence its mark (Z-0).
 */
import { DAY_MS } from "./hours.ts";

export type PlanWhat = "menu" | "recommendations" | "pdf";

export interface Planned {
  id: string;
  what: PlanWhat;
  /** The menu that goes on the net, or whose PDF it is. */
  menu: string;
  /** When, as a moment (ms UTC). */
  at: number;
  /** Who planned it, by name, and when. */
  by: string;
  madeAt: number;
  /** A recommendation for a folder (S62, Stufe 2, Z7); none: „Sonst“, the setting of before. */
  folder?: string;
  /** A PDF (S62 § 10.4): the link, the file in the business's store, its size and mark and language. */
  slot?: string;
  file?: string;
  bytes?: number;
  pages?: number;
  digest?: string;
  lang?: string;
}

export const PLAN_LIMITS = {
  /** At most so many waiting at once. */
  entries: 30,
  /** At most so far ahead. */
  ahead: 400 * DAY_MS,
} as const;

/** When „ab morgen“ begins (Martin, F4): a recommendation at 6:00, a menu at 0:00; always to be changed. */
export const PLAN_HOUR: Record<PlanWhat, number> = { recommendations: 360, menu: 0, pdf: 0 };

/** What a planned change does, in words: „QR-Code-Speisekarte“, „Empfehlungskarte“, „PDF-Link …“. */
export const planWhatText = (p: Pick<Planned, "what">, slotName = "") => (p.what === "menu" ? "QR-Code-Speisekarte" : p.what === "recommendations" ? "Empfehlungskarte" : `PDF-Link ${slotName}`.trim());
